import { Logger } from '@vimeo/logging';

import { liveApplicationConfig } from '../../configs/LiveApplicationConfig';

/**
 * Firebase actions logger.
 * Since built-in logger does not allow debugging and checking firebase actions and transactions
 * we should use own workaround middleware handlers to perform DB writing operations.
 *
 * The goal is to use many atomic operations instead of parallel async request that can be failed/cause corrupted state.
 */
export const firebaseLog: Logger = new Logger(
  '🔥FB',
  liveApplicationConfig.TRACKING.IS_FIREBASE_LOG_ENABLED,
);

export const firebaseSDKLog: Logger = new Logger(
  '🔥FB_SDK',
  liveApplicationConfig.TRACKING.IS_FIREBASE_SDK_LOG_ENABLED,
);

/**
 * Firebase events listeners registry.
 * Used to track how many subscription we have and whether we subscribe-unsubscribe from records correctly.
 */
export const firebaseListenersRegistry: Map<string, number> = new Map();
